import * as LJS from "../../lib/littlejs.esm";
import Globals from '../globals.ts';
import Object from "./object.ts";
class Spike extends Object {
    constructor(pos, world) {
        super(pos, 183, world, 203);
        this.fallDelay = 120;
        this.fallTimer = 0;
        this.isGoingToFall = false;
        this.isFalling = false;
        this.mass = 0; // Not affected by gravity
    }
    update() {
        super.update();
        if (this.disabled) {
            return;
        }
        // Check for overlap with player
        if (Globals.player && LJS.isOverlapping(this.pos, this.size, Globals.player.pos, Globals.player.size)) {
            Globals.player.takeDamage(1, true);
        }
    }
    defaultCollision() {
        this.setCollision(true, false, false, false);
    }
}
export default Spike;
